//Used for props type in SupplierContact.tsx


import {LanguageBaseView} from "../../LanguageModel/view/LanguageBaseView";
import {FileBaseView} from "../../FileModel/view/FileBaseView";
import {AffiliateBaseView} from "../../AffiliateModel/view/AffiliateBaseView";
import {CountryBaseView} from "../../CountryModel/view/CountryBaseView";
import {CompanyValidatedBaseView} from "../../CompanyValidatedModel/view/CompanyValidatedBaseView";
import {MessageBaseView} from "../../MessageModel/view/MessageBaseView";
import {ExpertRoleSubscriptionLevelConstants} from "../../ExpertRoleModel/constants/ExpertRoleContants";
import {AiFraudVerdictType} from "../../ExpertRoleModel/constants/AiFraudVerdictEnum";

export class MemberAsSupplierView {
    id: number;
    email: string;
    userGroupName: string;
    userGroupId: number;
    loginId: string;
    company: CompanyView | null;
    languageModel: LanguageBaseView | null;
    firstName: string;
    lastName: string;
    prefixe: number;
    portFolio: FileBaseView[];
    affiliate: AffiliateBaseView;
    promoOptOut: boolean;
    status: number;
    countPartnerRfp: number;
    blockReason: number
    blockExtra: string;
    paymentDueDays: number;
    purchaseOrder: string;
    companyHistoryModels: CompanyHistoryView[];
    memberContactModels: TeamMemberView[];
    expertRole: ExpertRoleView | null;
    userEmailsInvoice: UserEmailView[];
    userEmailsRappel: UserEmailView[];
    accountManagerId: number;
    accountManager: string;
    lastLoginDate: Date | null;
    remoteIpAddress: string;
    previousLoginDate: Date | null;
    previousRemoteIpAddress: string;
    statistics: string;
    appearInDirectory: boolean;
    userInterests: UserInterestView[];
    govexStatus: number;
    govexRegistrationDate: Date | null;
    aiFraudVerdict: AiFraudVerdictType | null;


    constructor(data?: any) {
        this.id = data?.id ?? 0
        this.email = data?.email ?? ""
        this.userGroupName = data?.userGroupName ?? ""
        this.userGroupId = data?.userGroupId ?? 0
        this.loginId = data?.loginId ?? ""
        this.company = data?.company ? new CompanyView(data.company) : null;
        this.languageModel = data?.languageModel ? new LanguageBaseView(data.languageModel) : null;
        this.firstName = data?.firstName ?? ""
        this.lastName = data?.lastName ?? ""
        this.prefixe = data?.prefixe ?? 0
        this.portFolio = data?.portFolio ?? []
        this.affiliate = data?.affiliate ?? null;
        this.promoOptOut = data?.promoOptOut ?? false
        this.status = data?.status ?? 0
        this.countPartnerRfp = data?.countPartnerRfp ?? 0
        this.blockReason = data?.blockReason ?? 0
        this.blockExtra = data?.blockExtra ?? ""
        this.paymentDueDays = data?.paymentDueDays ?? 0
        this.purchaseOrder = data?.purchaseOrder ?? ""
        this.companyHistoryModels = data?.companyHistoryModels ?? []
        this.memberContactModels = data?.memberContactModels ?? []
        this.expertRole = data?.expertRole ? new ExpertRoleView(data.expertRole) : null;
        this.userEmailsInvoice = data?.userEmailsInvoice ?? []
        this.userEmailsRappel = data?.userEmailsRappel ?? []
        this.accountManagerId = data?.accountManagerId ?? 0;
        this.accountManager = data?.accountManager ?? ""
        this.lastLoginDate = data?.lastLoginDate ? new Date(data.lastLoginDate) : null;
        this.remoteIpAddress = data?.remoteIpAddress ?? ""
        this.previousLoginDate = data?.previousLoginDate ? new Date(data.previousLoginDate) : null;
        this.previousRemoteIpAddress = data?.previousRemoteIpAddress ?? ""
        this.statistics = data?.statistics ?? ""
        this.appearInDirectory = data?.appearInDirectory ?? false
        this.userInterests = data?.userInterests ? data.userInterests.map((interest: any) => new UserInterestView(interest)) : [];
        this.govexStatus = data?.govexStatus ?? 0
        this.govexRegistrationDate = data?.govexRegistrationDate ? new Date(data.govexRegistrationDate) : null;
        this.aiFraudVerdict = data?.aiFraudVerdict ?? null;
    }

    /**
     * @deprecated should use an util or else to do that
     * Gets the translation key for the Govex status.
     * Based on the database translation keys: govexstatus.0, govexstatus.1, govexstatus.2, etc.
     */
    getGovexStatusTranslationKey(): string {
        return `govexstatus.${this.govexStatus}`;
    }
}

class CompanyHistoryView {

    id: number;
    acctSuffix: string;
    startDate: Date;
    endDate: Date;
    company: CompanyView;

    constructor(data?: any) {
        this.id = data?.id ?? 0
        this.acctSuffix = data?.acctSuffix ?? ""
        this.startDate = data?.startDate ?? new Date()
        this.endDate = data?.endDate ?? new Date()
        this.company = data?.company ?? new CompanyView()
    }
}

class CompanyView {

    id: number;
    name: string;
    address1: string;
    address2: string;
    city: string;
    zipCode: string;
    state: string;
    country: CountryBaseView
    regionName: string;
    phone: string;
    mobil: string;
    telValidated: CompanyValidatedBaseView[];
    website: string;
    tva: string;
    vatExempted: boolean;
    logo: string;
    companyType: string;
    department: string;
    function: string;
    juridicalFormModel: JuridicalFormView;
    differentInvoiceAddress: boolean;
    officeName: string;
    officeContactPerson: string;
    officeAddress1: string;
    officeAddress2: string;
    officeCity: string;
    officeState: string;
    officeZip: string;
    officeCountry: CountryBaseView;
    industryArea: IndustryAreaView;
    dateCreation: Date;
    numberOfEmployees: number;
    bankModels: BankView[];
    faxNumber: string;

    constructor(data?: any) {
        this.id = data?.id ?? 0
        this.name = data?.name ?? ""
        this.address1 = data?.address1 ?? ""
        this.address2 = data?.address2 ?? ""
        this.city = data?.city ?? ""
        this.zipCode = data?.zipCode ?? ""
        this.state = data?.state ?? ""
        this.country = data?.country ?? new CountryBaseView()
        this.regionName = data?.regionName ?? ""
        this.phone = data?.phone ?? ""
        this.mobil = data?.mobil ?? ""
        this.telValidated = data?.telValidated ?? []
        this.website = data?.website ?? ""
        this.tva = data?.tva ?? ""
        this.vatExempted = data?.vatExempted ?? false
        this.logo = data?.logo ?? ""
        this.companyType = data?.companyType ?? ""
        this.department = data?.department ?? ""
        this.function = data?.function ?? ""
        this.juridicalFormModel = data?.juridicalFormModel ?? ""
        this.differentInvoiceAddress = data?.differentInvoiceAddress ?? false
        this.officeName = data?.officeName ?? ""
        this.officeContactPerson = data?.officeContactPerson ?? ""
        this.officeAddress1 = data?.officeAddress1 ?? ""
        this.officeAddress2 = data?.officeAddress2 ?? ""
        this.officeCity = data?.officeCity ?? ""
        this.officeState = data?.officeState ?? ""
        this.officeZip = data?.officeZip ?? ""
        this.officeCountry = data?.officeCountry ?? new CountryBaseView()
        this.industryArea = data?.industryArea ?? new IndustryAreaView()
        this.dateCreation = data?.dateCreation ?? new Date()
        this.numberOfEmployees = data?.numberOfEmployees ?? 0
        this.bankModels = data?.bankModels ?? []
        this.faxNumber = data?.faxNumber ?? ""
    }
}

class BankView {
    id: number;
    bic: string;
    iban: string;
    typeMandate: number;
    mandateId: string;
    inviteUrl: string;
    status: number;
    country: CountryBaseView;

    constructor(data: any) {
        this.id = data?.id ?? 0
        this.bic = data?.bic ?? "";
        this.iban = data?.iban ?? "";
        this.typeMandate = data?.typeMandate ?? 0;
        this.mandateId = data?.mandateId ?? "";
        this.inviteUrl = data?.inviteUrl ?? "";
        this.status = data?.status ?? 0;
        this.country = data?.country ?? new CountryBaseView()
    }
}

class IndustryAreaView {
    id: number;
    name: string;

    constructor(data?: any) {
        this.id = data?.id ?? 0
        this.name = data?.name ?? ""
    }
}

class JuridicalFormView {


    id: number;
    country: CountryBaseView;
    name: MessageBaseView;
    shortName: MessageBaseView;


    constructor(data?: any) {
        this.id = data?.id ?? 0;
        this.country = data?.language ?? null;
        this.name = data?.name ?? "";
        this.shortName = data?.shortName ?? "";
    }


}

class ExpertRoleView {

    id: number;
    priceSystem: number;
    dailyMaxLeads: number;
    monthlyMaxLeads: number;
    expertRegions: ExpertRegionView[];
    languages: LanguageBaseView[];
    endDateHolidaysCapping: Date | null;
    startDateHolidaysCapping: Date | null;
    expertFrees: ExpertFreeView[];
    vendor: string;
    vendorId: number;
    banner: boolean;
    oldLeads: number;
    matchingOldLeads: number;
    allowLeadRejects: boolean;
    protestAllowed: number;
    protestComment: string;
    discount: number;
    expertRegistrationDate: Date;
    expertActivationDate: Date;
    appearInDirectory: boolean;
    maxMonthlyProtestAllowed: number;
    otherArea: string;
    subscLevel: number;
    hasIntegrationConfig: boolean;
    integrationLogCount: number;
    integrationErrorCount: number;
    /** When the expert role was last saved: the token a partial update sends back to detect a concurrent save. */
    dateUpdate: Date | string;

    constructor(data?: any) {
        this.id = data?.id ?? -1;
        this.priceSystem = data?.priceSystem ?? -1;
        this.dailyMaxLeads = data?.dailyMaxLeads ?? -1;
        this.monthlyMaxLeads = data?.monthlyMaxLeads ?? -1;
        this.expertRegions = data?.expertRegions ?? [];
        this.languages = data?.languages ?? [];
        this.endDateHolidaysCapping = data?.endDateHolidaysCapping ? data.endDateHolidaysCapping : null;
        this.startDateHolidaysCapping = data?.startDateHolidaysCapping ? data.startDateHolidaysCapping : null;
        this.expertFrees = data?.expertFrees ?? [];
        this.vendor = data?.vendor ?? "";
        this.vendorId = data?.vendorId ?? null;
        this.banner = data?.banner ?? false;
        this.oldLeads = data?.oldLeads ?? 0;
        this.matchingOldLeads = data?.matchingOldLeads ?? 15;
        this.allowLeadRejects = data?.allowLeadRejects ?? false;
        this.protestAllowed = data?.protestAllowed ?? 0;
        this.protestComment = data?.protestComment ?? "";
        this.discount = data?.discount ?? 0;
        this.expertRegistrationDate = data?.expertRegistrationDate ?? null;
        this.expertActivationDate = data?.expertActivationDate ?? null;
        this.appearInDirectory = data?.appearInDirectory ?? false;
        this.maxMonthlyProtestAllowed = data?.maxMonthlyProtestAllowed ?? 0;
        this.otherArea = data?.otherArea ?? "";
        this.subscLevel = data?.subscLevel ?? ExpertRoleSubscriptionLevelConstants.SUBSC_LEVEL_BASIC;
        this.hasIntegrationConfig = data?.hasIntegrationConfig ?? false;
        this.integrationLogCount = data?.integrationLogCount ?? 0;
        this.integrationErrorCount = data?.integrationErrorCount ?? 0;
        this.dateUpdate = data?.dateUpdate ?? "";
    }

    /** True when the supplier has a configured integration OR any dispatch activity. */
    hasIntegration(): boolean {
        return this.hasIntegrationConfig || this.integrationLogCount > 0;
    }
}

class ExpertFreeView {
    id: number;
    freeLeads: number;
    status: number;
    commentFree: string;
    maxfreeMonth: number;
    dateCreation: Date;

    constructor(data?: any) {
        this.id = data?.id ?? 0
        this.freeLeads = data?.freeLeads ?? 0
        this.status = data?.status ?? 0
        this.commentFree = data?.commentFree ?? ""
        this.maxfreeMonth = data?.maxfreeMonth ?? 0
        this.dateCreation = data?.dateCreation ?? new Date()
    }
}

class ExpertRegionView {

    id: number;
    regionId: number;
    regionName: string;
    regionCountryId: number;

    constructor(data: any) {
        this.id = data?.id ?? -1;
        this.regionId = data?.regionId ?? -1;
        this.regionName = data?.regionName ?? "";
        this.regionCountryId = data?.regionCountryId ?? -1;
    }
}

class TeamMemberView {
    email: string;
    firstname: string;
    lastname: string;
    function: string;
    skype: string;
    telNumber: string;
    hashedPassword: string;
    language: LanguageBaseView;
    id: number;
    teamUserGroup: TeamMemberUserGroupView;
    creationDate: Date;
    initials: string;


    constructor(data?: any) {
        this.email = data?.email ?? "";
        this.firstname = data?.firstname ?? "";
        this.lastname = data?.lastname ?? "";
        this.function = data?.function ?? "";
        this.skype = data?.skype ?? "";
        this.telNumber = data?.telNumber ?? "";
        this.hashedPassword = data?.hashedPassword ?? "";
        this.language = data?.language ?? new LanguageBaseView(data);
        this.id = data?.id ?? -1;
        this.teamUserGroup = data?.teamUserGroup ?? new TeamMemberUserGroupView(data);
        this.creationDate = data?.creationDate ?? new Date();
        this.initials = data?.firstname?.charAt(0).toUpperCase() + data?.lastname?.charAt(0).toUpperCase();
    }

    // getInitials function

    private getInitials(): string {
        const firstNameInitial = this.firstname.charAt(0).toUpperCase();
        const lastNameInitial = this.lastname.charAt(0).toUpperCase();
        return `${firstNameInitial}${lastNameInitial}`;
    }
}

class TeamMemberUserGroupView {
    id: number;
    name: string;

    constructor(data?: any) {
        this.id = data?.id ?? 1
        this.name = data?.name ?? ""
    }
}

class UserEmailView {
    //userEmailModel
    email: string;
    emailName: string;
    mailLanguage: LanguageBaseView;
    id: number;
    type: number;
    usage: number;

    constructor(data?: any) {
        this.email = data?.email ?? ""
        this.emailName = data?.emailName ?? ""
        this.mailLanguage = data?.mailLanguage ?? new LanguageBaseView()
        this.id = data?.id ?? 0
        this.type = data?.type ?? 0
        this.usage = data?.usage ?? 0
    }
}

class UserInterestView {
    id: number;
    textValue: string;
    parentInterest: InterestView | null;

    constructor(data?: any) {
        this.id = data?.id ?? 0;
        this.textValue = data?.textValue ?? "";
        this.parentInterest = data?.parentInterest ? new InterestView(data.parentInterest) : null;
    }
}


class InterestView {
    interestId: number;

    constructor(data?: any) {
        this.interestId = data?.interestId ?? 0;
    }
}